import { GAME_API_URL, GAME_API_KEY } from "../config/Constants";
import {
  GamePlayer,
  Player,
  RemoteGame,
  SocialNetwork,
  UserAccount,
  UserProfile,
} from "../types/Game";
import axios, { AxiosResponse } from "axios";
import PlayerService from "./PlayerService";

const validateStatus = (status: number) => {
  return status >= 200 && status < 500;
};

const apiInstance = axios.create({
  baseURL: GAME_API_URL,
  timeout: 30000,
  headers: {
    "x-api-key": GAME_API_KEY,
    "Content-Type": "application/json",
  },
});

const createProfile = (
  profile: UserProfile
): Promise<AxiosResponse<UserAccount>> => {
  return apiInstance.post("/api/profile", profile, { validateStatus });
};

const getRankingUsers = (): Promise<AxiosResponse<UserAccount[]>> => {
  return apiInstance.get<UserAccount[]>("/api/profile", { validateStatus });
};

const cleanExpiredRecords= (): Promise<AxiosResponse<UserAccount[]>> => {
  return apiInstance.get<UserAccount[]>("/api/profile/clean", { validateStatus });
};

const getGame = (gameId: string): Promise<AxiosResponse<RemoteGame>> => {
  return apiInstance.get<RemoteGame>(`/api/game/${gameId}`, { validateStatus });
};

const createGame = (
  userIdOwner: string
): Promise<AxiosResponse<RemoteGame>> => {
  return apiInstance.post<RemoteGame>(
    "/api/game",
    { userIdOwner },
    { validateStatus }
  );
};

const addPlayersToGame = (
  gameId: string,
  players: Player[]
): Promise<AxiosResponse<RemoteGame>> => {
  const filteredPlayers = players.filter(
    (item) => item.profile.socialNetwork
  );
  const gamePlayers: GamePlayer[] = filteredPlayers.map((player) => {
    return {
      userId: player.profile.userId,
      boardPosition: player.profile.boardPosition,
      points: PlayerService.getTotal(player.profile.points || []),
      timeStamp: player.profile.finishTimeStamp || 0,
    };
  });

  return apiInstance.post<RemoteGame>(
    `/api/game/${gameId}/player`,
    {players:gamePlayers},
    { validateStatus }
  );
};

const login = (
  socialNetwork: SocialNetwork,
  socialNetworkId: string
): Promise<AxiosResponse<UserAccount>> => {
  return apiInstance.post(
    "/api/profile/social/login",
    { socialNetwork, socialNetworkId },
    { validateStatus }
  );
};

export default {
  createProfile,
  login,
  getRankingUsers,
  createGame,
  getGame,
  addPlayersToGame,
  cleanExpiredRecords
};
